/* eslint-disable max-lines, eqeqeq */

import Pagination from 'rc-pagination';
import Rater from 'react-rater';
import React from 'react';
import ReactDOM from 'react-dom';
import 'rc-pagination/assets/index.css';
import 'react-rater/lib/react-rater.css';

import downloadGeoFile from '../utils/downloadGeoFile';
import CopyLinkButton from '../components/hike-ui/CopyLinkButton';
import ElevationProfile from '../components/ElevationProfile';
import ExpandableText from '../components/hike-ui/ExpandableText';
import FieldEditButton from '../components/hike-ui/FieldEditButton';
import FlagButton from '../components/hike-ui/FlagButton';
import MergeOverlapButton from '../components/hike-ui/MergeOverlapButton';
import SearchBox from '../components/SearchBox';
import PhotoLightBox from '../components/hike-ui/PhotoLightBox';
import PhotoMapWall from '../components/hike-ui/PhotoMapWall';
import {RegionType} from '../utils/gaia/RegionType';
import ReviewForm from '../components/hike-ui/ReviewForm';
import SaveRegionButton from '../components/hike-ui/SaveRegionButton';
import MonthlyTrendProfile from '../components/MonthlyTrendProfile';
import SortOptions from '../components/hike-ui/SortOptions';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {theme} from '../styles';
import {LngLat} from 'mapbox-gl';
import turfAlong from '@turf/along';
import trackAnalytics from '../utils/gaia/trackAnalytics';
import startReview from '../components/hike-ui/startReview';

window.HikeUI = {};

// add a bunch of react components to the DOM
window.HikeUI.initialize = options => {
    if (window.document.querySelector(options.selectors.sortOptions)) {
        ReactDOM.render(
            <SortOptions
                orderBy={options.pageDict.order_by}
                sort={options.pageDict.sort}
                minDistance={options.minDistance}
                maxDistance={options.maxDistance}
                activity={options.activity}
                useMetric={options.useMetric}
            />,
            window.document.querySelector(options.selectors.sortOptions)
        );
    }

    if (window.document.querySelector(options.selectors.pagination)) {
        ReactDOM.render(
            <Pagination
                onChange={window.hikeAppRoot.onPageChange}
                className='pagination'
                current={options.pageDict.page}
                total={options.pageDict.total_results}
                pageSize={options.pageDict.page_size} />,
            window.document.querySelector(options.selectors.pagination)
        );
    }

    window.HikeUI.renderPhotoMapWall(options);

    if (options.regionType === RegionType.KNOWN_ROUTE || options.regionType === RegionType.LAND) {
        ReactDOM.render(
            <MuiThemeProvider theme={theme}>
                <SaveRegionButton
                    hasActiveSubscription={options.hasActiveSubscription}
                    hasApp={options.hasApp}
                    localizableStrings={options.localizableStrings}
                    regionId={options.regionId}
                    regionType={options.regionType}
                    saved={options.saved}
                />
            </MuiThemeProvider>,
            window.document.querySelector(options.selectors.saveButton)
        );
    }

    if (window.document.querySelector(options.selectors.flagButton)) {
        // the flag button in the toolbar below the photos/map
        ReactDOM.render(
            <MuiThemeProvider theme={theme}>
                <FlagButton
                    flagged={options.flagged}
                    flaggedNote={options.flaggedNote}
                    regionId={options.regionId}
                    regionType={options.regionType}
                />
            </MuiThemeProvider>,
            window.document.querySelector(options.selectors.flagButton)
        );
    }

    if (window.document.querySelector(options.selectors.copyLinkButton)) {
        // the copy link button in the toolbar below the photos/map
        ReactDOM.render(
            <MuiThemeProvider theme={theme}>
                <CopyLinkButton
                />
            </MuiThemeProvider>,
            window.document.querySelector(options.selectors.copyLinkButton)
        );
    }

    if (window.document.querySelector(options.selectors.editButtonTitle)) {

        let startingEditTitle = options.originalTitle;
        if (options.userGeneratedName) {
            startingEditTitle = options.userGeneratedName;
        }

        // the edit button next to the title
        ReactDOM.render(
            <MuiThemeProvider theme={theme}>
                <FieldEditButton
                    afterUpdate={title => {
                        // use DOM because we want the title originally rendered statically for SEO
                        const titleSpan = document.getElementById('titleSpan');
                        titleSpan.innerHTML = title;
                        const breadcrumbsDiv = document.getElementById('breadcrumbs-name');
                        breadcrumbsDiv.innerHTML = title;
                    }}
                    anchorTitle={'edit'}
                    apiEndpoint={'update'}
                    apiType={'title'}
                    editedText={startingEditTitle}
                    editTitle={'Edit Title'}
                    regionId={options.regionId}
                    regionType={options.regionType}
                    originalText={options.originalTitle}
                />
            </MuiThemeProvider>,
            window.document.querySelector(options.selectors.editButtonTitle)
        );
    }

    if (window.document.querySelector(options.selectors.overlapCheckerTitle)) {
        ReactDOM.render(
            <MuiThemeProvider theme={theme}>
                <MergeOverlapButton
                    regionType={options.regionType}
                    regionId={options.regionId}
                    title={'Merge into routes'}
                />
            </MuiThemeProvider>,
            window.document.querySelector(options.selectors.overlapCheckerTitle)
        );
    }

    if (window.document.querySelector(options.selectors.expandableDescription)) {
        const hasUserGeneratedDescriptionText =
            options.userGeneratedDescription &&
            options.userGeneratedDescription.length > 1 &&
            options.userGeneratedDescription[1].text &&
            options.userGeneratedDescription[1].text.length > 0;
        ReactDOM.render(
            <MuiThemeProvider theme={theme}>
                <ExpandableText
                    anchorTitle={'Edit'}
                    apiEndpoint={'update'}
                    editedText={options.description == options.originalText ?
                        null :
                        options.description
                    }
                    editTitle={'Edit Description'}
                    expandDescriptionInitially={options.expandDescriptionInitially}
                    initialStaticDescription={options.initialStaticDescription}
                    lastEditedBy={options.userGeneratedUser}
                    regionId={options.regionId}
                    regionType={options.regionType}
                    originalText={options.originalDescription}
                    showExpandButton={(
                        hasUserGeneratedDescriptionText &&
                        !options.expandDescriptionInitially
                    )}
                    text={options.initialStaticDescription}
                />
            </MuiThemeProvider>,
            window.document.querySelector(options.selectors.expandableDescription)
        );
    }

    // show a star rating if this object is rated
    if (options.starCount) {
        // https://github.com/NdYAG/react-rater
        ReactDOM.render(
            <Rater
                total={5}
                rating={options.starCount}
                interactive={false}
                onRate={options.onRate}
            />,
            window.document.querySelector(options.selectors.stars)
        );
    }

    // show an elevation graph if elevation data exists for the object
    if (options.elevationProfile) {
        ReactDOM.render(
            <ElevationProfile
                elevation={options.elevationProfile}
                onMouseover={event => {
                    const mapMarker = turfAlong(
                        {type: 'Feature', geometry: options.geometry},
                        event.distance / 1000,
                        'kilometers'
                    );
                    window.mapMarker = mapMarker;
                    window.HikeUI.renderPhotoMapWall(options, mapMarker);
                }}
                onMouseout={() => window.HikeUI.renderPhotoMapWall(options, null)}
            />,
            window.document.querySelector(options.selectors.elevationGraph)
        );
    }

    // show monthly visits histogram if data exists for the object
    if (options.seasonProfile) {
        ReactDOM.render(
            <MonthlyTrendProfile
                months={options.seasonProfile}
                yAxisLabel="Visits"
            />,
            window.document.querySelector(options.selectors.seasonGraph)
        );
    }

    // show a review form for hikes
    if (options.regionType == RegionType.KNOWN_ROUTE) {
        ReactDOM.render(
            <MuiThemeProvider theme={theme}>
                <ReviewForm
                    userId={options.user.id}
                    reviews={options.reviews}
                    regionType={options.regionType}
                    regionId={options.regionId}
                />
            </MuiThemeProvider>,
            window.document.querySelector(options.selectors.reviewForm)
        );
    }

    window.HikeUI.renderSearchBox(options.mapCenter, options.selectors.search);
};


// the top component with photos and a map
window.HikeUI.renderPhotoMapWall = (
    options,
    mapMarker,
    highlightId,
    highlightPoint,
    highlightType,
    highlightIndex
// eslint-disable-next-line max-params
) => {

    // eslint-disable-next-line react/no-render-return-value
    const photoLightboxCom = ReactDOM.render(
        <PhotoLightBox
            photos={options.photos}
            isVisible={false}
            title={options.title}
            isStaff={options.isStaff}
            user={options.user}
            regionType={options.regionType}
            regionId={options.regionId}
        />,
        window.document.querySelector(options.selectors.lightboxContainer)
    );

    function switchContainers() {
        ReactDOM.render(
            <div />,
            window.document.querySelector(options.selectors.photoWall)
        );
        if (options.selectors.photoWall == '#photomapwall-container') {
            options.selectors.photoWall =  '#big-photomapwall-container';
        } else {
            options.selectors.photoWall =  '#photomapwall-container';
        }
        renderPhotoWallForOptions(options);
    }

    function renderPhotoWallForOptions(photoWallOptions) {
        ReactDOM.render(
            <PhotoMapWall
                centroid={photoWallOptions.centroid}
                cover_photo_id={photoWallOptions.cover_photo_id}
                extent={photoWallOptions.extent}
                geometry={photoWallOptions.geometry}
                highlightId={highlightId}
                highlightIndex={highlightIndex}
                highlightPoint={highlightPoint}
                highlightType={highlightType}
                isMapExpanded={options.selectors.photoWall == '#big-photomapwall-container'}
                mapMarker={mapMarker}
                photos={photoWallOptions.photos}
                photoCount={photoWallOptions.photoCount}
                photoLightboxCom={photoLightboxCom}
                regionId={options.regionId}
                regionType={options.regionType}
                reviews={options.reviews}
                startPoints={options.pageDict.route_start_points}
                startPointsExtent={options.pageDict.start_points_extent}
                switchContainersMethod={options.regionType != RegionType.KNOWN_ROUTE ?
                    () => switchContainers() :
                    null
                }
                title={photoWallOptions.title}
                onMapMove={event => {
                    const center = event.target.getCenter();
                    window.HikeUI.renderSearchBox(
                        new LngLat(center.lng, center.lat),
                        options.selectors.search
                    );
                }}
                user={options.user}
            />,
            window.document.querySelector(photoWallOptions.selectors.photoWall)
        );
    }

    renderPhotoWallForOptions(options);

};

window.HikeUI.renderSearchBox = (center, selector) => {
    ReactDOM.render(
        <MuiThemeProvider theme={theme}>
            <SearchBox center={center} />
        </MuiThemeProvider>,
        window.document.querySelector(selector)
    );
};

// Called when a a user is directed to a hike page by a drip email.
window.HikeUI.startReview = startReview;

/*
    TOOLBAR FUNCTIONS
*/

window.hikeAppRoot = {};

// https://stackoverflow.com/questions/37531142
window.hikeAppRoot.getDirections = (lat, lng) => {
    let directionsUrl;
    switch (true) {
        case (/ipad|iphone|ipod/i.test(navigator.userAgent.toLowerCase())):
            // eslint-disable-next-line max-len
            directionsUrl = 'https://maps.google.com/?saddr=Current+Location&daddr=loc:' + lat + ',' + lng;
            break;
        case (/windows phone 7/i.test(navigator.userAgent.toLowerCase())):
            directionsUrl = 'maps:' + lat + ',' + lng;
            break;
        case (/windows phone 8/i.test(navigator.userAgent.toLowerCase())):
        // eslint-disable-next-line max-len
            directionsUrl = 'ms-drive-to:?destination.latitude=' + lat + '&destination.longitude=' + lng;
            break;
        case (/android/i.test(navigator.userAgent.toLowerCase())):
            directionsUrl = 'google.navigation:q=' + lat + ',' + lng;
            break;
        case (/blackberry/i.test(navigator.userAgent.toLowerCase())):
            // eslint-disable-next-line max-len
            directionsUrl = 'javascript:blackberry.launch.newMap({\'nav_end\':{\'latitude\':' + lat + ',\'longitude\':' + lng + '}})';
            break;
        default:
            directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + lat + ',' + lng;
    }
    trackAnalytics('Driving Directions', {category: 'Hike', url: directionsUrl});
    window.open(directionsUrl, '_blank', '');
};


window.hikeAppRoot.downloadFile = (fileDownloadUrl, permalink, cb) => {
    downloadGeoFile(fileDownloadUrl, permalink, cb);
    trackAnalytics('Download File', {
        category: 'Hike',
        url: fileDownloadUrl,
        permalink: permalink
    });
};


window.hikeAppRoot.printMap = () => {
};

/*
    PAGINATION FUNCTIONS
*/


window.hikeAppRoot.onPageChange = (page, pageSize) => {
    let url = window.location.href;
    url = window.hikeAppRoot.updateQueryString('p', page, url);
    url = window.hikeAppRoot.updateQueryString('n', pageSize, url);
    trackAnalytics('Changed Page', {category: 'Hike', page: page, pageSize: pageSize});
    window.location.href = url;
};

window.hikeAppRoot.updateQueryString = (key, value, url) => {
    const re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi');
    let hash;

    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null) {
            return url.replace(re, '$1' + key + '=' + value + '$2$3');
        } else {
            hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) { url += '#' + hash[1]; }
            return url;
        }
    } else if (typeof value !== 'undefined' && value !== null) {
        const separator = url.indexOf('?') !== -1 ? '&' : '?';
        hash = url.split('#');
        url = hash[0] + separator + key + '=' + value;
        if (typeof hash[1] !== 'undefined' && hash[1] !== null) { url += '#' + hash[1]; }
        return url;
    } else {
        return url;
    }
};
